import styled from "styled-components";
import colors from "assets/scss/colors.scss";

const PersonalDetailValueWrapper = styled.div`
  padding: 0;
  .personal-details-head {
    background: #f2f3f5;
    box-shadow: 0px 4px 10px rgba(9, 30, 66, 0.06);
    border-radius: 12px;
    padding: 24px;
    text-align: initial;
    margin-bottom: 20px;
    h2 {
      font-weight: 800;
      font-size: 1.3rem;
      color: #4c565c;
    }
    h4 {
      font-weight: 800;
      font-size: 1rem;
      color: #4c565c;
      padding-left: 25px;
    }
    .username {
      display: flex;
    }
    .name {
      margin-top: 5px;
    }
    .pi {
      color: ${colors["bright-purple"]};
      display: inline-block;
      margin-right: 10px;
      margin-top: 3px;
    }
    i.pi.pi-user {
      border: 1px solid ${colors["bright-purple"]};
      border-radius: 50%;
      padding: 2px;
      margin-top: 1px;
      font-size: 13px;
    }
    p {
      font-weight: 400;
      font-size: 0.8rem;
      display: inline-block;
      color: #676f7c;
      margin-bottom: 3px;
      margin-top: -1px;
    }
    .rborder {
      border-right: 1px solid #c7c8c959;
      padding: 0 20px;
    }
  }
  .personal-details-head.ar {
    text-align: right;
    .rborder {
      border: none !important;
      border-left: 1px solid #c7c8c959;
    }

    h4 {
      padding-right: 35px;
    }
    .pi {
      margin-left: 10px;
    }
  }

  @media only screen and (max-width: 575.99px) {
    .personal-details-head {
      // display: none;
    }
    .rborder {
      padding: 0 !important;
    }
  }
`;
export default PersonalDetailValueWrapper;
